export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '/authentication',
        children: [
          {
            path: '/',
            component: () => import('./Client/Client.vue'),
            props: true,
          },
          {
            path: '*',
            component: () => import('./NotFound/NotFound.vue'),
            props: true,
          },
        ],
      },
    ]);
  },
};
